var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8 3H6.7587C6.46743 3 6.19456 2.99999 5.93928 3.00208C5.4121 3.0064 5 3.43971 5 3.9669C5 4.54228 5.48794 5.00469 6.06331 5.00136C6.28431 5.00008 6.52836 5 6.8 5H13.2C14.0566 5 14.6389 5.00078 15.089 5.03755C15.5274 5.07337 15.7516 5.1383 15.908 5.21799C16.2843 5.40973 16.5903 5.7157 16.782 6.09202C16.8617 6.24842 16.9266 6.47262 16.9624 6.91104C16.9992 7.36113 17 7.94342 17 8.8V15.2C17 16.0566 16.9992 16.6389 16.9624 17.089C16.9266 17.5274 16.8617 17.7516 16.782 17.908C16.5903 18.2843 16.2843 18.5903 15.908 18.782C15.7516 18.8617 15.5274 18.9266 15.089 18.9624C14.6389 18.9992 14.0566 19 13.2 19H6.8C6.52836 19 6.28431 18.9999 6.06331 18.9986C5.48794 18.9953 5 19.4577 5 20.0331C5 20.5603 5.4121 20.9936 5.93928 20.9979C6.19455 21 6.46741 21 6.75868 21H6.8H13.2H13.2413C14.0463 21 14.7106 21 15.2518 20.9558C15.8139 20.9099 16.3306 20.8113 16.816 20.564C17.5686 20.1805 18.1805 19.5686 18.564 18.816C18.8113 18.3306 18.9099 17.8139 18.9558 17.2518C19 16.7106 19 16.0463 19 15.2413V15.2V8.8V8.75868C19 7.95372 19 7.28936 18.9558 6.74817C18.9099 6.18608 18.8113 5.66937 18.564 5.18404C18.1805 4.43139 17.5686 3.81947 16.816 3.43597C16.3306 3.18868 15.8139 3.09012 15.2518 3.04419C14.7106 2.99998 14.0463 2.99999 13.2413 3H13.2H6.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29289 14.2929C8.90237 14.6834 8.90237 15.3166 9.29289 15.7071C9.68342 16.0976 10.3166 16.0976 10.7071 15.7071L13.7071 12.7071C14.0976 12.3166 14.0976 11.6834 13.7071 11.2929L10.7071 8.29289C10.3166 7.90237 9.68342 7.90237 9.29289 8.29289C8.90237 8.68342 8.90237 9.31658 9.29289 9.70711L11.5858 12L9.29289 14.2929Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11H6C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ea871ab486d34ce569bd37440388ab51.svg";
export { ForwardRef as ReactComponent };